var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPencilLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20154_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45872 12.2857C3.49443 12.2857 3.53015 12.2821 3.56586 12.2768L6.56943 11.75C6.60515 11.7428 6.63908 11.7268 6.66408 11.7L14.2337 4.13033C14.2503 4.11381 14.2634 4.09419 14.2724 4.07259C14.2813 4.05098 14.2859 4.02783 14.2859 4.00444C14.2859 3.98105 14.2813 3.95789 14.2724 3.93629C14.2634 3.91469 14.2503 3.89507 14.2337 3.87855L11.2659 0.908902C11.2319 0.874974 11.1873 0.857117 11.1391 0.857117C11.0909 0.857117 11.0462 0.874974 11.0123 0.908902L3.44265 8.47855C3.41586 8.50533 3.39979 8.53747 3.39265 8.57319L2.86586 11.5768C2.84849 11.6724 2.8547 11.7709 2.88395 11.8636C2.91319 11.9563 2.9646 12.0405 3.03372 12.1089C3.15158 12.2232 3.29979 12.2857 3.45872 12.2857ZM4.66229 9.1714L11.1391 2.6964L12.448 4.00533L5.97122 10.4803L4.38372 10.7607L4.66229 9.1714ZM14.5712 13.7857H1.42836C1.11229 13.7857 0.856934 14.041 0.856934 14.3571V15C0.856934 15.0785 0.921219 15.1428 0.999791 15.1428H14.9998C15.0784 15.1428 15.1426 15.0785 15.1426 15V14.3571C15.1426 14.041 14.8873 13.7857 14.5712 13.7857Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20154_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencilLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil_line.e3c5073d.svg";
export { ForwardRef as ReactComponent };